const scene = "order/";
export const UPDATE_ORDERS = `${scene}UPDATE_ORDERS`;
export const UPDATE_FILTER = `${scene}UPDATE_FILTER`;
export const UPDATE_REDUCER = `${scene}UPDATE_REDUCER`;

